import React from "react";
import HeroPP from "../Components/Hero/HeroPP";

const PrivacyPolicy = () => {
  return (
    <>
      <HeroPP />
      <section className="st-about-wrap" id="about">
        <div className="container">
          <div className="col-lg">
            <p>
              Your privacy is critically important to us. This Privacy Policy
              explains how we collect, use, and protect your personal
              information when you use our platform.
            </p>

            <h4>1. Information We Collect</h4>
            <ul>
              <li>
                <b>Personal Data: </b>Name, email address, phone number, and
                other details provided during registration.
              </li>
              <li>
                <b>Verification Data: </b>Additional documents or information
                required for manual verification and approval of your account by
                our moderators.
              </li>
              <li>
                <b>Usage Data: </b>Device information, IP address, and activity
                logs.
              </li>
            </ul>

            <h4>2. How We Use Your Data</h4>
            <p>
              We collect and use your data to:
              <ul>
                <li>
                  Verify and manually approve registrations, ensuring a safe and
                  trusted community.
                </li>
                <li>Provide and improve app services.</li>
                <li>Communicate important updates and notifications.</li>
                <li>
                  Maintain community safety and security by preventing fake
                  profiles.
                </li>
              </ul>
            </p>

            <h4>
              3. Content Moderation & Community Guidelines (EULA Compliance)
            </h4>
            <p>
              By using the Dotor Anjana Community app, you agree to follow our
              community guidelines:
              <ul>
                <li>
                  <b>No Objectionable Content: </b>Users must not post or share
                  harmful, offensive, or illegal content.
                </li>
                <li>
                  <b>Respectful Conduct: </b>Harassment, abuse, and any form of
                  harmful behavior are strictly prohibited.
                </li>
                <li>
                  <b>Verified Membership: </b>All registrations are manually
                  verified to ensure authenticity and prevent fake profiles.
                </li>
                <li>
                  <b>Reporting Mechanism: </b>Users can report concerns
                  regarding content or members via Support → Contact Us in the
                  app.
                </li>
              </ul>
            </p>

            <h4 id="child-safety">4. Child Safety & Protection Policy</h4>
            <p>
              Dotor Anjana Community is committed to preventing child
              exploitation and abuse. Our app has strict measures in place to
              detect and remove any content that violates child protection laws.
            </p>
            <ul>
              <li>
                <b>Strictly Prohibited: </b>Any form of child exploitation,
                abuse, or inappropriate content.
              </li>
              <li>
                <b>Manual Verification: </b>All new user registrations are
                reviewed to prevent fake profiles.
              </li>
              <li>
                <b>Reporting System: </b>Users can report concerns via Support →
                Contact Us in the app.
              </li>
              <li>
                <b>Action on Reports: </b>Our support team reviews all reports
                within 24 hours and takes necessary actions.
              </li>
              <li>
                <b>Law Enforcement Compliance: </b>We fully cooperate with law
                enforcement in investigating CSAE-related cases.
              </li>
            </ul>
            <p>
              If you come across any inappropriate content, please report it
              immediately at{" "}
              <a href="mailto:support@dotor.org">support@dotor.org</a>.
            </p>

            <h4>5. How We Handle Reports & Violations</h4>
            <ul>
              <li>
                Our support team reviews reports and takes action within 24
                hours as necessary.
              </li>
              <li>
                If a user is found violating our guidelines, we reserve the
                right to remove content or suspend the account.
              </li>
            </ul>

            <h4>6. Data Sharing & Security</h4>
            <ul>
              <li>
                We do not share your personal data with third parties, except as
                required by law.
              </li>
              <li>
                We implement strong security measures, but users are responsible
                for keeping their accounts secure.
              </li>
            </ul>

            <h4>7. User Rights & Data Control</h4>
            <p>
              You can request access, modification, or deletion of your personal
              data by contacting us at{" "}
              <a href="mailto:support@dotor.org">support@dotor.org</a>.
            </p>

            <h4>8. Cookies & Tracking</h4>
            <p>
              The app may use cookies or similar technologies for analytics and
              functionality.
            </p>

            <h4>9. Updates to This Policy</h4>
            <p>
              We may update this Privacy Policy. Continued use of the app
              signifies your agreement to the latest terms.
            </p>

            <p>
              For any questions or concerns, contact us at{" "}
              <a href="mailto:support@dotor.org">support@dotor.org</a>.
            </p>

            <div className="st-height-b125 st-height-lg-b25" />
            <div className="st-height-b0 st-height-lg-b30" />
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
